import * as actionTypes from './actionTypes';
import axios from 'axios';

export const authStart = () => {
    return{
        type:actionTypes.AUTH_START
    }
}

export const authSuccess = (token,userId) => {
    return{
        type:actionTypes.AUTH_SUCCESS,
        token:token,
        userId:userId
    }
}

export const setAuthRedirectPath = (path)=>{
    return{
        type:actionTypes.SET_AUTH_REDIRECT_PATH,
        path:path
    }
}

export const authFail = (error) => {
    return{
        type:actionTypes.AUTH_FAIL,
        error:error
    }
}

export const authLogout = ()=>{
    localStorage.removeItem('expirationTime');
    localStorage.removeItem('token');
    localStorage.removeItem('id');
    return{
        type:actionTypes.AUTH_LOGOUT
    }
}

export const checkAuthTimeout = (expiresIn) => {
    return dispatch=>{
        setTimeout(()=>{
            dispatch(authLogout());
        },expiresIn*1000);
    }
}

export const auth = (email,password,isSignUp) => {
    return dispatch=>{
        dispatch(authStart());
        const authData={
            email:email,
            password:password,
            returnSecureToken:true
        }
        let url='https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyBc2SGT64HfLk2HFISLrX1HlTUzJIF8GrY';
        if(!isSignUp){
            url='https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyBc2SGT64HfLk2HFISLrX1HlTUzJIF8GrY';
        }
        axios.post(url,authData)
                .then((res)=>{
                    const expirationDate=new Date(new Date().getTime()+res.data.expiresIn*1000);
                    localStorage.setItem('token',res.data.idToken);
                    localStorage.setItem('expirationTime',expirationDate);
                    localStorage.setItem('id',res.data.localId);
                    dispatch(authSuccess(res.data.idToken,res.data.localId));
                    dispatch(checkAuthTimeout(res.data.expiresIn));
                })
                .catch(err=>{
                    console.log(err);
                    dispatch(authFail(err.response.data.error));
                });
    }
}

export const checkAuthState = ()=>{
    return dispatch=>{
        const token=localStorage.getItem('token');
        if(!token){
            dispatch(authLogout());
        }else{
            const expirationTime=new Date(localStorage.getItem('expirationTime'));
            if(expirationTime<new Date()){
                dispatch(authLogout());
            }else{
                dispatch(authSuccess(token,localStorage.getItem('id')));
                dispatch(checkAuthTimeout((expirationTime.getTime()-new Date().getTime())/1000));
            }
        }
    }
}